import React from 'react';

const PaperRow = ({ hit, onPlay, onDownload }) => (
  <div className="bg-white rounded-xl px-6 py-4 shadow-sm border border-gray-200 hover:shadow-md transition-shadow flex items-center gap-4">
    <div className="flex-1 min-w-0">
      <div className="flex items-center gap-2 mb-1 flex-wrap">
        <span className="text-xs font-medium text-indigo-600 bg-indigo-50 px-2 py-0.5 rounded-full">{hit.category}</span>
        {hit.isFree ? (
          <span className="text-xs font-semibold text-green-600 bg-green-50 px-2 py-0.5 rounded-full">Free</span>
        ) : (
          <span className="text-xs font-semibold text-purple-600 bg-purple-50 px-2 py-0.5 rounded-full">Premium</span>
        )}
      </div>
      <h3 className="font-semibold text-gray-900 truncate">{hit.title}</h3>
      <p className="text-sm text-gray-500 truncate">{hit.description}</p>
    </div>

    <div className="text-sm text-gray-400 flex-shrink-0 hidden sm:flex items-center gap-1">
      <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
        <path d="M18 3a1 1 0 00-1.196-.98l-10 2A1 1 0 006 5v9.114A4.369 4.369 0 005 14c-1.657 0-3 .895-3 2s1.343 2 3 2 3-.895 3-2V7.82l8-1.6v5.894A4.369 4.369 0 0015 12c-1.657 0-3 .895-3 2s1.343 2 3 2 3-.895 3-2V3z" />
      </svg>
      {hit.duration}
    </div>

    <div className="flex items-center gap-2 flex-shrink-0">
      <button
        onClick={() => onPlay(hit)}
        className="stripe-gradient text-white py-2 px-4 rounded-lg text-sm font-medium hover:opacity-90 transition-opacity flex items-center gap-2"
      >
        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z" clipRule="evenodd" />
        </svg>
        Play
      </button>
      <button
        onClick={() => onDownload(hit)}
        className="border border-gray-300 text-gray-700 py-2 px-3 rounded-lg text-sm font-medium hover:border-gray-400 transition-colors"
      >
        PDF
      </button>
    </div>
  </div>
);

export default PaperRow;
